export default __webpack_public_path__ + "59a49b0f545f3f597c46bce7ef52b4cb.woff2";